import React, { useEffect, useState } from "react";
import axios from "axios";

import { Link } from "react-router-dom";
import { toastError, toastSuccess } from "../../../common/Toast";
import { SUCCESS_MESSAGE, ERROR_MESSAGE } from "../../../common/Constant";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../components/Loader/Loader";
import config from "../../../config/config";
import CustomFieldcard from "../../../pages/MainPages/Receiving/CustomFieldcard";

const CustomFIeldConfigReceiving = (props) => {
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");

  const [loading, setLoading] = useState(false);
  const [cardData, setCardData] = useState([
    {
      Id: 0,
      Name: "",
      TypeId: 1,
      Optionvalue: "",
      ShowOnReceipt: 0,
      HideFieldLabel: 0,
      Required: 0,
      Locations: "",
    },
  ]);

  const addCard = () => {
    const cardInput = {
      Id: 0,
      Name: "",
      TypeId: 1,
      Optionvalue: "",
      ShowOnReceipt: 0,
      HideFieldLabel: 0,
      Required: 0,
      Locations: "",
    };

    setCardData([...cardData, cardInput]);
  };

  const handleChangeCard = (index, evnt) => {
    // console.log("aasdjg",evnt.target.checked);
    console.log(evnt.target);

    let name, values;
    if (evnt.target === undefined) {
      name = "Optionvalue";
      values = evnt.toString();
    } else {
      if (evnt.target.type === "checkbox") {
        name = evnt.target.name;
        if (evnt.target.checked === true) {
          values = 1;
        } else {
          values = 0;
        }
      } else {
        name = evnt.target.name;
        values = evnt.target.value;
      }
    }

    console.log(index, name, values);
    const cardInput = [...cardData];
    cardInput[index][name] = values;
    setCardData(cardInput);
  };
  console.log("cardData", cardData);

  const handleSubmit = () => {
    let data = cardData.filter(function (cardData) {
      return cardData.Name != "";
    });

    const jsonobj = {};
    jsonobj.customfieldXml = data;

    let jsonstring = JSON.stringify(jsonobj);

    setLoading(true);

    axios
      .post(
        `${config.receivingBaseUrl}/receivings/upsertreceivingscustomfield`,
        {
          xmlcustomfield: jsonstring,
          loginuserid: loginUserId,
          // attributesxml: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res from customfield", res);
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError("Name" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
        window.location.reload();
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `${config.receivingBaseUrl}/receivings/customfieldgetall?receivingid=${loginUserId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        console.log("dtasssa", response);
        const responseData = response.data.ResponseData;
        console.log(responseData);
        if (responseData.length !== 0) {
          setCardData(responseData);
        }

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  console.log("card Datttttaataaa",cardData)

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div className="page-header" 
          style={
            {
              position: "fixed",
              top: "2px",
              zIndex: "999"
            }
          }
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Receiving</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item"  style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/Receiving">Receiving List</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link>Receiving Custom Fields</Link>
                </li>
              </ul>
            </div>
          </div>
          <form>
            {/* {divs} */}
            <div className="card">
              <div className="card-body">
                <div className="add">
                  <CustomFieldcard
                    cardData={cardData}
                    handleChange={handleChangeCard}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-dark btn-sm pull-left mt-2"
                    onClick={addCard}
                  >
                    <i className="fa fa-plus fa-sm p-1" />
                    Add CustomFields
                  </button>
                </div>

                <div className="save pull-right">
                  <Link
                    to="/suppliers"
                    className="btn btn-secondary btn-sm me-1 mt-2"
                  >
                    Cancel
                  </Link>
                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="btn btn-primary btn-sm mx-2 mt-2"
                  >
                    {" "}
                    Save
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CustomFIeldConfigReceiving;
